const AUTH_TOKEN_KEY = "authToken";
const AUTH_USER_KEY = "authUser";

class Auth {

    getToken() {
        return sessionStorage.getItem(AUTH_TOKEN_KEY);
    }

    getUser() {
        const value = sessionStorage.getItem(AUTH_USER_KEY);

        if (!value) return null;

        try {
            return JSON.parse(value);
        } catch {
            return null;
        }
    }

    isLoggedIn() {
        return !!this.getToken();
    }

    async login(username, password) {

        const response = await fetch("/api/auth/login", {
            method: "POST",

            headers: {
                "Content-Type": "application/json",

                "X-Device-Id": this.getDeviceId(),
                "X-Device-Name": this.getDeviceName(),
                "X-Device-Type": this.getDeviceType(),
                "X-Device-OS": this.getOS(),
                "X-Device-Browser": this.getBrowser(),
            },

            body: JSON.stringify({
                username,
                password
            }),
        });

        const data = await response.json();

        if (!response.ok || !data.success) {
            throw new Error(data.message || "Login gagal");
        }

        // =========================
        // SIMPAN SESSION
        // =========================

        sessionStorage.setItem(
            AUTH_TOKEN_KEY,
            data.session.token
        );

        sessionStorage.setItem(
            AUTH_USER_KEY,
            JSON.stringify(data.user)
        );

        console.log("[AUTH] Login berhasil");
        console.log("[AUTH] User:", data.user.username);

        return data;
    }

    async register(username, password, fullName, departemen) {

        const response = await fetch("/api/auth/register", {
            method: "POST",

            headers: {
                "Content-Type": "application/json",
            },

            body: JSON.stringify({
                username,
                password,
                full_name: fullName,
                departemen
            }),
        });

        let data;

        try {

            data = await response.json();

        } catch {

            throw new Error(
                "Server memberikan response yang tidak valid"
            );

        }

        if (!response.ok || !data.success) {

            throw new Error(
                data.message || "Pendaftaran akun gagal"
            );

        }

        console.log("[AUTH] Registrasi berhasil");
        console.log("[AUTH] User:", data.user?.username);

        return data;
    }

    // ========================================
    // HEARTBEAT
    // ========================================

    async heartbeat() {

        const token =
            this.getToken();

        if (!token) {
            return false;
        }

        try {

            const response =
                await fetch(
                    "/api/auth/heartbeat",
                    {
                        method: "POST",

                        headers: {
                            "Authorization":
                                `Bearer ${token}`,
                        },
                    }
                );

            if (!response.ok) {

                console.warn(
                    "[AUTH] Heartbeat failed:",
                    response.status
                );

                return false;
            }

            const data =
                await response.json();

            if (data.success) {

                console.log(
                    "[AUTH] Heartbeat OK:",
                    data.last_activity
                );

                return true;
            }

            return false;

        } catch (error) {

            console.error(
                "[AUTH] Heartbeat error:",
                error
            );

            return false;
        }
    }


    async me() {

        const token = this.getToken();

        if (!token) return null;

        const response = await fetch("/api/auth/me", {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });

        if (!response.ok) {
            this.clear();
            return null;
        }

        const data = await response.json();

        if (!data.success) {
            this.clear();
            return null;
        }

        return data;
    }

    async logout() {

        const token = this.getToken();

        if (token) {

            try {

                await fetch("/api/auth/logout", {
                    method: "POST",

                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                });

            } catch (error) {

                console.error(
                    "[AUTH] Logout request failed:",
                    error
                );

            }
        }

        this.clear();

        console.log("[AUTH] Logout");
    }

    clear() {

        sessionStorage.removeItem(AUTH_TOKEN_KEY);
        sessionStorage.removeItem(AUTH_USER_KEY);

    }

    getDeviceId() {

        // DEVICE ID tetap localStorage
        // supaya browser/device tetap dikenali

        let deviceId = localStorage.getItem("deviceId");

        if (!deviceId) {

            deviceId = crypto.randomUUID();

            localStorage.setItem(
                "deviceId",
                deviceId
            );
        }

        return deviceId;
    }

    getDeviceName() {

        return navigator.userAgent.includes("Mobile")
            ? "Mobile Device"
            : "Desktop";
    }

    getDeviceType() {

        return navigator.userAgent.includes("Mobile")
            ? "mobile"
            : "desktop";
    }

    getOS() {

        const ua = navigator.userAgent;

        if (/Android/i.test(ua)) return "Android";
        if (/iPhone|iPad|iPod/i.test(ua)) return "iOS";
        if (/Windows/i.test(ua)) return "Windows";
        if (/Mac/i.test(ua)) return "macOS";
        if (/Linux/i.test(ua)) return "Linux";

        return "Unknown";
    }

    getBrowser() {

        const ua = navigator.userAgent;

        if (/Firefox/i.test(ua)) return "Firefox";
        if (/Edg/i.test(ua)) return "Edge";
        if (/Chrome/i.test(ua)) return "Chrome";
        if (/Safari/i.test(ua)) return "Safari";

        return "Unknown";
    }
}

export default new Auth();